export default __webpack_public_path__ + "static/screenshot4-95b2c5f9464e51d121b126e1d9622e99.jpg";